import $ from 'domtastic'

import { uID } from '../../utils/utils'
import YTIframe from '../../templates/yt-iframe.hbs'

import BaseComponent from './_BaseComponent'




/* YOUTUBE IFRAME API
---------------------------------------------------------------------------------------------------- */

export default class YouTubeIframe extends BaseComponent {

    constructor($el, namespace) {
        super('yt', $el, namespace)

        this.$iframesCtn = $('.js-iframeCtn')

        this.preCheck()
        this.init()
        this.bindEvents()

        this.on()

        $(document).on('cookieConsentChanged', () => {
            this.preCheck()
            this.init()
            this.bindEvents()
        })
    }

    preCheck() {
        this.shouldInit = this.$iframesCtn.length > 0 && APP.CookieConsent.hasAccepted('functional')
    }


    init() {
        if (!this.shouldInit) return

        const tag = document.createElement('script')
        tag.src = 'https://www.youtube.com/iframe_api'

        const scriptTag = document.getElementsByTagName('script')[0]
        scriptTag.parentNode.insertBefore(tag, scriptTag)
    }


    bindEvents() {
        if (!this.shouldInit) return

        window.onYouTubeIframeAPIReady = () => this.onYouTubeIframeAPIReady()
    }




    /* Handlers
    --------------------------------------------------------- */

    onYouTubeIframeAPIReady() {
        this.videos = this.$iframesCtn.map(($iframeCtn) => {
            const $ctn = $iframeCtn.closest('.videoCtn')
            const $playBtn = $ctn.querySelector('.js-playBtn')
            const $v = $(YTIframe({
                uid: uID(),
                src: $iframeCtn.dataset.src,
                title: $iframeCtn.dataset.title,
            }))


            $ctn.classList.remove('is-unplayable')
            $($iframeCtn).append($v)


            return {
                $ctn,
                $playBtn,

                // eslint-disable-next-line no-undef
                YTPlayer: new YT.Player($v[0].id, {
                    playerVars: {
                        rel: 0,
                        controls: 0,
                        modestbranding: 1,
                    },
                    events: {
                        onStateChange: e => onPlayerStateChange(e, $ctn),
                    },
                }),
            }
        })


        this.videos.forEach((v) => {
            this.bindListener(v.$playBtn, 'click', (e) => { this.onClick(e, v) })
        })
    }


    // eslint-disable-next-line class-methods-use-this
    onClick(e, { YTPlayer }) {
        e.preventDefault()

        YTPlayer.playVideo()
    }

}




/* CONSTANTS & HELPERS
---------------------------------------------------------------------------------------------------- */

const onPlayerStateChange = ({ target: player }, $ctn) => {
    const state = player.getPlayerState()

    $ctn.classList.toggle('is-playing', state !== 0 && state !== 2)
}



